export * from './checkToken';
export * from './flattenObject';
export * from './route';
export * from './dateTimeFormat';
export * from './number';
export * from './permissionAlias';

export const accountPasswordRegex =
    /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{}|;:,.<>?])[A-Za-z\d!@#$%^&*()_+\-=[\]{}|;:,.<>?]{8,16}$/;
